/* eslint-disable */
import * as THREE from '../../../libs/three.js/build/three.module.js';

// Geometry
export const radius = 0.2;
export const sphereGeometry = new THREE.SphereGeometry(radius, 6, 6);
export const sphereGeometryHighlighted = new THREE.SphereGeometry(1, 128, 128);

// Materials — BackSide for the large focus sphere (viewed from inside),
//             FrontSide for small marker balls (viewed from outside).
export const sphereMaterial = new THREE.MeshBasicMaterial({
  side: THREE.BackSide,
  color: 0xffffff,
});
export const sphereMarkerMaterial = new THREE.MeshBasicMaterial({
  side: THREE.FrontSide,
  color: 0xffffff,
});
export const sphereMaterialHovered = new THREE.MeshBasicMaterial({
  side: THREE.FrontSide,
  color: 0xff0000,
});

// Raycaster
export const raycaster = new THREE.Raycaster();

// State variables (using getter/setter pattern for module-level mutability)
let _currentlyHovered = null;
let _previouslyHovered = null;
let _currentlyFocused = null;
let _hovering = false;

export function getCurrentlyHovered() { return _currentlyHovered; }
export function setCurrentlyHovered(value) { _currentlyHovered = value; }

export function getPreviouslyHovered() { return _previouslyHovered; }
export function setPreviouslyHovered(value) { _previouslyHovered = value; }

export function getCurrentlyFocused() { return _currentlyFocused; }
export function setCurrentlyFocused(value) { _currentlyFocused = value; }

export function isHovering() { return _hovering; }
export function setHovering(value) { _hovering = value; }

// Edit state variables
let _courseLocal = 0;
let _pitchLocal = 0;
let _rollLocal = 0;
let _posXLocal = 0;
let _posYLocal = 0;
let _posZLocal = 0;

export function getCourseLocal() { return _courseLocal; }
export function setCourseLocal(value) { _courseLocal = value; }

export function getPitchLocal() { return _pitchLocal; }
export function setPitchLocal(value) { _pitchLocal = value; }

export function getRollLocal() { return _rollLocal; }
export function setRollLocal(value) { _rollLocal = value; }

export function getPosXLocal() { return _posXLocal; }
export function setPosXLocal(value) { _posXLocal = value; }

export function getPosYLocal() { return _posYLocal; }
export function setPosYLocal(value) { _posYLocal = value; }

export function getPosZLocal() { return _posZLocal; }
export function setPosZLocal(value) { _posZLocal = value; }

// Reset all local edit values
export function resetLocalValues() {
  _courseLocal = 0;
  _pitchLocal = 0;
  _rollLocal = 0;
  _posXLocal = 0;
  _posYLocal = 0;
  _posZLocal = 0;
}

// Previous view state
let _previousView = {
  controls: null,
  position: null,
  target: null,
};

export function getPreviousView() { return _previousView; }
export function setPreviousView(value) { _previousView = value; }

// Accepted images array
let _image360Accepted = [];

export function getImage360Accepted() { return _image360Accepted; }
export function addToImage360Accepted(image) { _image360Accepted.push(image); }
export function removeFromImage360Accepted(index) { _image360Accepted.splice(index, 1); }
export function replaceInImage360Accepted(index, image) { _image360Accepted.splice(index, 1, image); }
export function clearImage360Accepted() { _image360Accepted = []; }
export function isInImage360Accepted(image) { return _image360Accepted.includes(image); }
export function indexInImage360Accepted(image) { return _image360Accepted.indexOf(image); }

